import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import { store } from '../../store/store';
import { Provider } from 'react-redux';
import TreatmentModal from './TreatmentModal';
import { DOMModalContextProvider } from '../../Services/DOMModalContext';
import AclContextProvider from '../../Modules/Acl/Components/AclContextProvider';
import React from 'react';

loadDOMComponent({
	selector: 'react-treatment-modal',
	callback: ({ container, context }) => {
		const patientId = container.getAttribute('patientId');
		const toggleId = container.getAttribute('toggleId');

		const opened = false;

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<DOMModalContextProvider toggleId={toggleId}>
							<TreatmentModal opened={opened} patientId={patientId} />
						</DOMModalContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
